/* ============================================================
   AM2T — Product Card hover video
   When a product card's 2nd media is a video, play it on
   mouseenter, pause + reset on mouseleave. Cards without video
   skip silently (CSS-only image swap handles the rest).
   ============================================================ */

(() => {
  'use strict';

  const bindCard = (card) => {
    if (card.dataset.hoverBound === 'true') return;
    card.dataset.hoverBound = 'true';

    const video = card.querySelector('[data-hover-video]');
    if (!video) return;

    card.addEventListener('mouseenter', () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => { /* autoplay blocked — silently fail to poster */ });
      }
    });

    card.addEventListener('mouseleave', () => {
      video.pause();
      try { video.currentTime = 0; } catch { /* ignore */ }
    });
  };

  const bindAll = () => {
    document.querySelectorAll('.product-card:not([data-hover-bound])').forEach(bindCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }

  // Re-bind for dynamically inserted cards (cart drawer, AJAX updates, etc.)
  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('.product-card')) bindCard(node);
          node.querySelectorAll?.('.product-card:not([data-hover-bound])').forEach(bindCard);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
